import * as angular from "angular";
import {IController, IQService, ITimeoutService} from "angular";
import * as _ from "lodash";
import {DataSet} from "vis-data";
import {ResourcesAlertsService} from "../../../resources/services/resources-alerts.service";
import {LeanPlanningService} from "../../services/lean-planning-service.service";
import {BringozTimelineService} from "../../../commons/services/bringoz-timeline-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {TaskModel} from "../../../tasks/models/task.model";

export class RoutesTimelineComponent implements IController {
  from: any;
  to: any;
  routes: any;
  tasks: any;
  tasksListType: any;
  selectedItemId: any;
  zoom: any;
  canEdit: any;
  queryString: any;
  usePurposeColor: any;
  hiddenRouteIds: Function;
  onTaskSelection: Function;
  onMovedItem: Function;
  onZoomChange: Function;
  onAddSuggestionsToRoute: Function;
  onRecalcRoute: Function;
  onDeleteRoute: Function;
  onToggleRoute: Function;

  public container: any;
  public vis: any;
  public options: any;
  public timeline: any;
  public topElementRef: any;
  public tableHeaderDivRef: any;
  public groupsDataSet: any;
  public itemsDataSet: any;
  public readonly taskPurposeToColorMap: any;
  public readonly SITE_WEIGHT_UNIT: any;
  public readonly SITE_VOLUME_UNIT: any;
  public readonly IS_PRICING_ENABLED: any;
  // public actionsByStatusMap: any;
  public headerNode: any;
  public movingItem: any;

  public iconsUrl: any;
  public readonly $weightIcon: any;
  public readonly $volumeIcon: any;
  public readonly $packageIcon: any;
  public readonly $spotIcon: any;
  public $eyeIcon: any;
  public $menuIcon: any;

  // Single delegated click handler for group-row actions, attached once on
  // `this.container` after the timeline is created. Replaces 2 per-cell
  // `addEventListener` calls (actionsDiv + eyeButton) inside `groupTemplate` /
  // `_createEyeButton`. The `actionsDiv` action panel was originally
  // synchronous (no `_onClicked()` hop); preserve that by special-casing
  // `route-action-panel`.
  private readonly _onContainerClick = (event: Event) => {
    const target = event.target as Element | null;
    if (!target) return;
    const actionEl = target.closest('[data-bz-action]') as HTMLElement | null;
    if (!actionEl) return;
    const action = actionEl.dataset.bzAction;
    const id = actionEl.dataset.bzId;
    if (!action || !id) return;

    if (action === 'route-action-panel') {
      if (!this.canEdit) return;
      this.commonsService.openActionPanel(['Reoptimize', 'Delete'], event)
        .then((reason: string) => {
          if (_.isEqual(reason, 'Reoptimize')) {
            this.onRecalcRoute({routeId: id});
          } else if (_.isEqual(reason, 'Delete')) {
            this.onDeleteRoute({routeId: id});
          }
        })
        .catch((reason: any) => {
          this.$log.info('Action Panel Closed', reason);
        });
      return;
    }

    this._onClicked().then(() => {
      if (action === 'toggle-route') {
        // NOTE: `hiddenRouteIds` is typed as `Function` in this file (binding
        // is `'&'`); cast preserves the original call shape used elsewhere.
        const currentlyEnabled = !_.includes(this.hiddenRouteIds as any, id);
        this.onToggleRoute({id: id, isEnabled: !currentlyEnabled});
      }
    });
  };

  constructor(private $q: IQService, private confirmDialogService: ConfirmDialogService, private $filter, private $timeout: ITimeoutService, private commonsService: CommonsService,
              private tasksConstants, private commonsDialogService: CommonsDialogService, private $log, private splitService,
              private IAMPermissions, private leanPlanningConstants, private bringozTimelineService: BringozTimelineService,
              private leanPlanningService: LeanPlanningService, private moment, private resourcesAlertsService: ResourcesAlertsService) {

    this.vis = require('vis-timeline');
    this.taskPurposeToColorMap = this.tasksConstants.purposeToColor;
    this.SITE_WEIGHT_UNIT = this.$filter('translate')(splitService.getWeightUnit());
    this.SITE_VOLUME_UNIT = this.$filter('translate')(splitService.getVolumeUnit());
    this.IS_PRICING_ENABLED = this.IAMPermissions.hasPermission('priceplan.list');


    this.iconsUrl = {
      late: 'assets/images/icons/v2/info-outline.svg',
      relations: 'assets/images/icons/v2/relation.svg',
      address: 'assets/images/icons/v2/location-pin.svg',
      weight: 'assets/images/icons/v2/weight.svg',
      volume: 'assets/images/icons/v2/volume.svg',
      etaWindow: 'assets/images/icons/v2/timer.svg',
      timeWindow: 'assets/images/icons/v2/time-window.svg',
      relation: 'assets/images/icons/v2/relation.svg',
      eyeOn: 'assets/images/icons/v2/show.svg',
      eyeOff: 'assets/images/icons/v2/hide.svg',
      linkTo: 'assets/images/icons/v2/link-to.svg',
      package: 'assets/images/icons/v2/package.svg',
      account: 'assets/images/icons/v2/account.svg',
      eye: 'assets/images/icons/v2/show.svg',
      menu: 'assets/images/icons/v2/menu.svg',
      agent: {
        Driver: 'assets/images/icons/agents/driver_flat.svg',
        ServiceAgent: 'assets/images/icons/agents/serviceagent_flat.svg'
      },
      spot: 'assets/images/icons/v2/spot.svg'
    }


    this.$weightIcon = document.createElement('IMG');
    this.$weightIcon.setAttribute("src", this.iconsUrl.weight);
    this.$weightIcon.classList.add('bringoz-icon-small', 'gray');

    this.$volumeIcon = document.createElement('IMG');
    this.$volumeIcon.setAttribute("src", this.iconsUrl.volume);
    this.$volumeIcon.classList.add('bringoz-icon-small', 'gray');

    this.$packageIcon = document.createElement('IMG');
    this.$packageIcon.setAttribute("src", this.iconsUrl.package);
    this.$packageIcon.classList.add('bringoz-icon-small', 'gray');

    this.$spotIcon = document.createElement('IMG');
    this.$spotIcon.setAttribute("src", this.iconsUrl.spot);
    this.$spotIcon.classList.add('bringoz-icon-small', 'gray');

    this.$eyeIcon = document.createElement('IMG');
    this.$eyeIcon.setAttribute("src", this.iconsUrl.eye);
    this.$eyeIcon.classList.add('bringoz-icon');

    this.$menuIcon = document.createElement('IMG');
    this.$menuIcon.setAttribute("src", this.iconsUrl.menu);
    this.$menuIcon.classList.add('bringoz-icon-small', 'gray');

    this.headerNode = {
      route: document.createElement('span'),
      agent: document.createElement('span')
    };
    this.headerNode.route.textContent = $filter('translate')('Route');
    this.headerNode.agent.textContent = $filter('translate')('Driver');
  }

  $onInit() {
    // Check permissions to update roues
    if (_.isUndefined(this.canEdit)) {
      this.canEdit = this.IAMPermissions.hasPermission('planning.routes.update') ? this.canEdit : false;
    }

    // create visualization
    this.container = document.getElementById('timeline');

    // Set Timeline
    this.groupsDataSet = new DataSet()
    this.itemsDataSet = new DataSet()

    // Set Options
    this.options = {
      // option groupOrder can be a property name or a sort function
      // the sort function must compare two groups and return a value
      //     > 0 when a > b
      //     < 0 when a < b
      //       0 when a == b
      groupOrder: (a, b) => {
        return a.value - b.value;
      },
      groupOrderSwap: (groupDragged, groupToSwap, groups) => {
        const value = groupDragged.value;
        groupDragged.value = groupToSwap.value;
        groupToSwap.value = value;
      },
      groupTemplate: (group) => {

        if (!group) {
          return null;
        }
        const container = document.createElement('div');
        container.classList.add("table-container");

        let columns = [
          {key: 'route', values: [group.id, group.status]},
          {key: 'scheduling', values: [group.date, group.timeWindow]},
          {key: 'resource', values: [group.supplyResourceName, group.agentName]},
          {key: 'del', values: [group.del]},
          {key: 'cost', values: [group.cost]},
          {key: 'distance', values: [group.distance]},
          {key: 'alerts', values: [group.alerts]},
          {key: 'progress', values: [group.stats || {}]},
          {
            key: 'capacity', values: [
              {v: group.weight, max: group.maxWeight, icon: this.$weightIcon, unit: this.SITE_WEIGHT_UNIT},
              {v: group.volume, max: group.maxVolume, icon: this.$volumeIcon, unit: this.SITE_VOLUME_UNIT},
              {v: group.packagesCount, max: group.maxPackagesCount, icon: this.$packageIcon},
              {v: group.spotsCount, max: group.maxSpotsCount, icon: this.$spotIcon}
            ]
          },
          {key: 'serviceAreas', values: []}
        ];

        if (!this.IS_PRICING_ENABLED) {
          columns = _.filter(columns, (c) => {
            return c.key !== 'cost';
          })
        }

        const actionsContainer = document.createElement('div');
        actionsContainer.classList.add("table-item", 'action-item-container');

        const actionsDiv = document.createElement('div');
        actionsDiv.classList.add("route-actions");
        actionsDiv.style.setProperty('background-color', group.color);

        const actionsButton = this.$menuIcon.cloneNode(true);
        actionsButton.classList.add("bringoz-icon");
        actionsDiv.appendChild(actionsButton);

        const eyeButton = this._createEyeButton(group.id, !_.includes(this.hiddenRouteIds, group.id));

        const iconsDiv = document.createElement('div');
        iconsDiv.classList.add("group-action-div");
        iconsDiv.appendChild(eyeButton);

        actionsContainer.appendChild(actionsDiv);
        actionsContainer.appendChild(iconsDiv);
        container.insertAdjacentElement('beforeend', actionsContainer);

        if (group.id) {
          actionsDiv.dataset.bzAction = 'route-action-panel';
          actionsDiv.dataset.bzId = String(group.id);
        }

        _.forEach(columns, (c) => {
          const element = document.createElement('div');

          element.classList.add("table-item", "br-caption-2", c.key);
          _.forEach(c.values, (value, index) => {
            let valueElement

            if (c.key === 'route') {
              valueElement = document.createElement('div');

              if (index === 0) {
                const routeIdSpan = document.createElement('span');
                routeIdSpan.classList.add("br-body-1", c.key);
                routeIdSpan.textContent = value;
                valueElement.appendChild(routeIdSpan);
              } else {
                const statusDiv = document.createElement('div');
                const statusSpan = document.createElement('span');
                statusDiv.classList.add("route-status", c.key, group.status);
                statusSpan.textContent = value;
                statusDiv.appendChild(statusSpan);
                valueElement.appendChild(statusDiv);
              }
            }
              // else if(c.key === 'scheduling') {
              //   valueElement = document.createElement('div');
              //
              //   _.forEach(c.values, function(v, index) {
              //     if (index === 0) {
              //       var routeDate = document.createElement('span');
              //       routeDate.classList.add( "br-body-1", c.key);
              //       routeDate.innerHTML = value;
              //       valueElement.appendChild(routeDate);
              //     } else {
              //       var routeTimeWindow = document.createElement('a');
              //       routeTimeWindow.classList.add("br-body-1", c.key);
              //       routeTimeWindow.innerHTML = value;
              //       valueElement.appendChild(routeTimeWindow);
              //     }
              //   })
            // }
            else if (c.key === 'resource') {
              valueElement = document.createElement('div');

              if (index === 0) {
                const resourceName = document.createElement('div');
                resourceName.classList.add("br-body-1", c.key);
                resourceName.textContent = value;
                valueElement.appendChild(resourceName);
              } else {
                const agentName = document.createElement('div');
                agentName.classList.add("br-body-1", c.key);
                agentName.textContent = value;
                valueElement.appendChild(agentName);
              }
            } else if (c.key === 'alerts') {
              valueElement = document.createElement('div');
              valueElement.classList.add("br-body-1");

              const warningCount = document.createElement('span');
              warningCount.textContent = value || '---';

              if (!!value) {
                warningCount.classList.add("warn");
              }
              valueElement.appendChild(warningCount);
            } else if (c.key === 'progress') {
              valueElement = document.createElement('div');
              valueElement.classList.add("br-body-1");

              const percentageSpan = document.createElement('span');
              const percentage = _.toString((value.finished || 0) * 100 / (value.total || 0));
              percentageSpan.textContent = percentage + '%';

              valueElement.appendChild(percentageSpan);
            } else if (c.key === 'capacity') {
              valueElement = document.createElement('div');
              const span = document.createElement('span');
              span.classList.add("item-value", "br-body-1", "font-weight-400", c.key);

              if (!value.v) {
                value.v = 0;
              }
              if (!value.max) {
                value.max = this.$filter('translate')('UNLIMITED');
              } else if (value.v > value.max) {
                span.classList.add("warn");
              }

              valueElement.classList.add("item-value", c.key, "text-ellipsis");

              span.textContent = value.v + '/' + value.max + ' ' + (value.unit || '');

              valueElement.appendChild(angular.copy(value.icon));
              valueElement.appendChild(span);
            } else if (c.key === 'agent') {
              if (index === 0) {
                valueElement = document.createElement('span');
                valueElement.classList.add("br-body-1", "font-weight-400");
                valueElement.textContent = value;
              }
              if (index === 1) {
                valueElement = document.createElement('div');
                const skillsContainer = document.createElement('div');
                skillsContainer.classList.add('skill-tags-container');
                _.forEach(value, (s, i) => {

                  const skill = document.createElement('div');
                  skill.classList.add('skill-tag', 'skill-tag-margin');

                  const skillText = document.createElement('span')
                  skillText.classList.add("item-value", "br-body-1", "font-weight-400", c.key);
                  skillText.textContent = s;
                  skill.appendChild(skillText);
                  skillsContainer.appendChild(skill);
                })
                valueElement.appendChild(skillsContainer);
              }
            } else {
              valueElement = document.createElement('span');
              valueElement.classList.add("br-body-1", "font-weight-400");
              valueElement.textContent = value;
            }

            if (valueElement) {
              valueElement.classList.add("item-value", c.key);
              element.insertAdjacentElement('beforeend', valueElement);
            }
          });
          container.insertAdjacentElement('beforeend', element);
        });

        return container;
      },
      onMoving: (item, callback) => {
        const groupMovingTo = _.find(this.routes, (r) => {
          return r.rid === item.group
        });

        const actions = this.leanPlanningService.getRoutesActionsMap([groupMovingTo]);

        if (!actions.editRoute) {
          this.resourcesAlertsService.timelineRouteIsBlocked();
          callback(null);
          return;
        }

        if (item.content != null) {
          callback(item); // updating the item
        } else {
          callback(null); // cancel updating the item
        }
      },
      onMove: (item, callback) => {
        const fromRouteId = item.routeId;
        const toRouteId = item.group;
        const toRouteRef = _.find(this.routes, (r) => {
          return r.id === toRouteId;
        })
        const serviceId = item.serviceId;

        const actions = this.leanPlanningService.getRoutesActionsMap([toRouteRef]);

        if (!actions.editRoute) {
          this.resourcesAlertsService.timelineRouteIsBlocked();
          callback(null);
          return;
        }

        if (!!toRouteRef.isBlockedByUser) {
          this.resourcesAlertsService.timelineRouteIsBlocked();
          callback(null);
          return;
        }

        callback(item);
        const canMove = this._canItemMove(item);

        if (!canMove) {
          callback(null);
          return;
        }

        this.confirmDialogService.confirm('Move Delivery From Route', 'Are you sure you want to move this item?', event)
          .then(() => {
            const groupsMap = this.timeline.components[3].groups;
            const isBetweenRoutes = fromRouteId !== toRouteId;

            this.onMovedItem(
              {
                serviceId: serviceId,
                fromRouteId: fromRouteId,
                toRouteId: isBetweenRoutes ? toRouteId : fromRouteId,
                fromOrderedIds: _.chain(
                  groupsMap[fromRouteId].orderedItems.byStart)
                  .filter((item) => {
                    return !_.isEqual(item.data.type, 'background');
                  })
                  .map((filteredItem) => {
                    return filteredItem.data.id;
                  })
                  .value(),
                toOrderedIds: isBetweenRoutes ?
                  _.chain(
                    groupsMap[toRouteId].orderedItems.byStart)
                    .filter((item) => {
                      return !_.isEqual(item.data.type, 'background');
                    })
                    .map((filteredItem) => {
                      return filteredItem.data.id;
                    })
                    .value() : undefined
              }
            );
            callback(null);
          })
          .catch(() => {
            callback(null);
          })
          .finally(() => {
            this.movingItem = undefined;
          })
      },
      onAdd: (data, callback) => {

        if (!data.items || !data.items.length) {
          callback(null);
          return;
        }

        this.onAddSuggestionsToRoute({routeId: data.group, ids: _.map(data.items, 'id')});
      },
      snap: (date, scale, step) => {
        const minute = 60 * 1000;
        return Math.round(date / minute) * minute;
      },
      orientation: 'top',
      editable: {
        add: this.canEdit,                             // add new items by double tapping
        updateTime: this.canEdit,               // drag items horizontally
        updateGroup: this.canEdit,              // drag items from one group to another
        remove: false,                          // delete an item by tapping the delete button top right
        overrideItems: false                    // allow these options to override item.editable
      },
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      groupEditable: true,
      verticalScroll: true,
      zoomKey: 'ctrlKey',
      width: '100%',
      height: '100%',
      margin: {
        item: 5
      },
      stack: false,
      showTooltips: true,
      tooltip: {
        followMouse: true
      },
      start: this.from ? this.moment(this.from).subtract(1, 'hour') : this.moment().startOf('day'),
      end: this.to ? this.moment(this.to).add(1, 'hour') : this.moment().endOf('day'),
      min: this.from ? this.moment(this.from).subtract(1, 'hour') : '',
      max: this.to ? this.moment(this.to).add(1, 'hour') : '',
      zoomMin: 1080000, // Zoom In Max 5 Mins
      // zoomMax: 18800000 // Zoom Out Max 1 Hour,
    };

    this.timeline = new this.vis.Timeline(this.container, [], this.options);

    // Single delegated click handler — replaces per-cell addEventListener calls
    // inside groupTemplate so listener count stays O(1) regardless of vis redraws.
    this.container.addEventListener('click', this._onContainerClick);

    // Set Table Header Element
    const topElementRef = this.timeline.body.dom.top;
    topElementRef.style = 'left: 0px';
    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("table-header-container");
    topElementRef.before(this.tableHeaderDivRef);

    let headers = [
      {key: '', value: ''},
      {key: 'route', value: 'Route'},
      {key: 'scheduling', value: 'Scheduling'},
      {key: 'resource', value: 'Resource'},
      {key: 'del', value: 'Del'},
      {key: 'cost', value: 'Cost'},
      {key: 'distance', value: 'Distance'},
      {key: 'alerts', value: 'Alerts'},
      {key: 'progress', value: 'Progress'},
      {key: 'capacity', value: 'Capacity'},
      {key: 'serviceAreas', value: 'Service Areas'}
    ];

    if (!this.IS_PRICING_ENABLED) {
      headers = _.filter(headers, (h) => {
        return h.key !== 'cost';
      })
    }

    _.forEach(headers, (h) => {
      const element = document.createElement('div');
      element.classList.add("table-header-item", "br-caption-2", (h.key || 'actions'));
      element.textContent = this.$filter('translate')(h.value);
      this.tableHeaderDivRef.appendChild(element);
    });

    // Set Timeline
    this.timeline.setGroups(this.groupsDataSet);
    this.timeline.setItems(this.itemsDataSet);

    // Timeline Events
    this.timeline.on('select', (properties) => {
      this._onTaskClicked().then(() => {
        const selectedTask = this._getTimelineTaskById(properties.items[0]);
        this.onTaskSelection({taskId: _.get(selectedTask, 'taskId')});
      });
    });
  }

  $onChanges(changes: angular.IOnChangesObject) {

    if (changes.routes && !changes.routes.isFirstChange()) {


      const currentRoutes = changes.routes.currentValue || [];
      const previousRoutes = changes.routes.previousValue || [];

      const routesToAdd = _.differenceBy(currentRoutes, previousRoutes, 'id');
      const routesToRemove = _.differenceBy(previousRoutes, currentRoutes, 'id');


      const currentUpdatedRoutes = _.differenceBy(currentRoutes, routesToAdd, 'id');
      const previousUpdatedRoutes: any = _.differenceBy(previousRoutes, routesToRemove, 'id');

      const currentRoutesToUpdate = _.filter(currentUpdatedRoutes, (currentUpdatedRoute: any) => {
        const previousUpdatedRoute = _.find(previousUpdatedRoutes, ['id', currentUpdatedRoute.id]);
        // Check if route was changed
        return previousUpdatedRoute.updatedTime < currentUpdatedRoute.updatedTime;
      });

      // Routes - REMOVE LINE TASKS
      if (!!routesToRemove.length) {
        this.groupsDataSet.remove(_.map(routesToRemove, 'id'));
        this.itemsDataSet.remove(_.map(routesToRemove, 'id'));
      }

      // Routes - UPDATE LINE TASKS
      if (!!currentRoutesToUpdate.length) {
        const updatedRouteItems = [];
        _.forEach(currentRoutesToUpdate, (r) => {
          updatedRouteItems.push(this._getRouteBackgroundItem(r));
        })
        this.groupsDataSet.update(this._mapRoutesToGroups(currentRoutesToUpdate));
        this._updateTimelineTasks(updatedRouteItems);
      }

      // Routes - ADD LINE TASKS
      if (routesToAdd.length) {
        this.groupsDataSet.add(this._mapRoutesToGroups(routesToAdd));
        this._addBackgroundItemToRoutes(routesToAdd);
      }

      this.redrawGroupTemplate();
    }

    if (changes.tasks && !changes.tasks.isFirstChange()) {
      const currentTasks = changes.tasks.currentValue || [];
      this.updateAllRoutesTasks(currentTasks);
    }

    if (changes.selectedItemId && !changes.selectedItemId.isFirstChange()) {
      const selectedTask = this._getTimelineTaskById(this.selectedItemId);
      if (selectedTask) {
        this.timeline.setSelection(selectedTask.id);
      }
    }

    if (changes.from && !changes.from.isFirstChange() ||
      changes.to && !changes.to.isFirstChange()) {

      this.options.min = this.moment(this.from).subtract(1, 'hour');
      this.options.max = this.moment(this.to).add(1, 'hour');
      this.timeline.setOptions(this.options);
    }

    if (changes.queryString && !changes.queryString.isFirstChange()) {
      this._setGroupVisibilityByQueryString(this.queryString);
    }

    if (changes.zoom && !changes.zoom.isFirstChange()) {
      if (!_.isUndefined(this.zoom)) {
        this.zoom ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
        this.onZoomChange();
      }
    }

  }

  // ******************************
  //        Public methods
  // ******************************

  public onFit() {
    this.$timeout(200).then(() => {
      this.timeline.fit();
      // ctrl.onFit();
    });
  }

  public onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }

  // ******************************
  //        Private methods
  // ******************************

  private _updateTimelineTasks(taskItems) {
    const itemsToUpdate = [];

    this.itemsDataSet.forEach((item) => {
      if (_.includes(_.map(taskItems, 'id'), _.get(item, 'id'))) {
        itemsToUpdate.push(item.id);
      }
    });
    this.itemsDataSet.update(_.filter(taskItems, (t) => {
      return _.includes(itemsToUpdate, t.id)
    }));
  }

  private _addBackgroundItemToRoutes(routes) {
    let backgroundItems = [];

    _.forEach(routes, (r) => {
      backgroundItems = backgroundItems.concat(this._getRouteBackgroundItem(r));
    });

    this.itemsDataSet.add(backgroundItems);
  }

  private redrawGroupTemplate() {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      updatedGroups.push(group);
    });

    this.groupsDataSet.update(updatedGroups);
    // timeline.setGroups(updatedGroups);
  }

  private updateAllRoutesTasks(tasks) {
    let tasksToAdd = [];
    let idsToRemove = [];
    let idsToUpdate = [];


    const taskIds = _.flatMap(tasks, 'id');
    const currentTimelineItems = [];
    this.itemsDataSet.forEach((item) => {
      if (item.type !== 'background') {
        currentTimelineItems.push(item.id);

        if (_.includes(taskIds, item.id)) {
          const taskRef = _.find(tasks, (t) => {
            return t.id === item.id;
          })
          if (_.get(taskRef, 'updatedAt', 0) >= _.get(item, 'updatedAt', 0)) {
            idsToUpdate.push(item.id);
          }
        }

      }
    });
    idsToRemove = _.filter(currentTimelineItems, (currentItemId) => {
      return !_.includes(taskIds, currentItemId);
    })
    tasksToAdd = _.filter(tasks, (t) => {
      return !_.includes(currentTimelineItems, t.id);
    })

    // Remove
    if (idsToRemove.length) {
      this.itemsDataSet.remove(idsToRemove);
    }

    // Update
    if (idsToUpdate.length) {
      const tasksToUpdate = _.filter(tasks, (t) => {
        return _.includes(idsToUpdate, t.id);
      })
      const taskItemsToUpdate = this._getItemsData(tasksToUpdate);

      if (_.get(taskItemsToUpdate, 'length')) {
        this.itemsDataSet.remove(_.map(taskItemsToUpdate, 'id'))
        this.itemsDataSet.add(taskItemsToUpdate);

        // itemsDataSet.update(taskItemsToUpdate);
      }
    }

    // Add
    if (tasksToAdd.length) {
      const taskItemsToAdd = this._getItemsData(tasksToAdd);

      if (_.get(taskItemsToAdd, 'length')) {
        this.itemsDataSet.remove(_.map(taskItemsToAdd, 'id'))
        this.itemsDataSet.add(taskItemsToAdd);
      }
    }
  }

  private _mapRoutesToGroups(routes) {
    return _.map(routes, (route, index) => {
      return this._getGroupData(route, index);
    });
  }

  private _getGroupData(route, index) {
    const assignedCid = _.get(route, 'assignedCid');
    const isBlockedByUser = _.get(route, 'isBlockedByUser');
    return {
      id: route.rid,
      // className: 'group-row md-tiny',
      className: `group-row md-tiny ${isBlockedByUser ? 'blocked' : ''}`,
      value: index,
      color: route.color || 'black',
      status: route.status,
      date: this.$filter('bringozDate')(route.notBefore),
      timeWindow: this.$filter('timeWindow')({notBefore: route.notBefore, notAfter: route.notAfter}),
      agentName: assignedCid && route.agentReference ? this.$filter('userName')(route.agentReference) : '---',
      requiredSkills: this._getTranslatedAgentSkills(_.get(route, 'requiredSkills', []), true),
      del: _.get(route, 'serviceIdList.length', 0),
      cost: this.$filter('bringozPrice')(route.courierPrice),
      distance: this.$filter('bringozDistance')(route.totalDistanceMeter),
      alerts: _.get(route, 'stats.notPacked', 0),
      stats: _.get(route, 'stats', {}),
      maxLoad: _.get(route, 'maxLoad'),
      weight: _.get(route, 'maxLoad.weightLoad'),
      maxWeight: _.get(route, 'maxLoad.weight'),
      volume: _.get(route, 'maxLoad.calculatedVolume'),
      maxVolume: _.get(route, 'maxLoad.dimensions.cube'),
      packagesCount: _.get(route, 'maxLoad.numberOfItemsLoad'),
      maxPackagesCount: _.get(route, 'maxLoad.numberOfItems'),
      spotsCount: _.get(route, 'maxLoad.numberOfSpotsLoad'),
      maxSpotsCount: _.get(route, 'maxLoad.numberOfSpots'),
      supplyResourceName: _.get(route, 'supplyResourceName', '---')
    }
  }

  private _getItemsData(tasks) {

    return _.map(tasks, (task: TaskModel) => {
      const routeRef = _.find(this.routes, route => {
        return route.id === task.routeId
      })
      const routeColor = _.get(routeRef, 'color', 'black');
      const index = _.get(task, 'routeAnalysis.daySequence');

      const taskPurpose = task.taskSpec.purpose;
      const taskServiceTime = _.get(task, 'routeAnalysis.serviceTime');
      const isPoint = _.isEqual(task.taskType, 'Internal');
      const isBundle = _.isEqual(task.taskType, 'BundledStopover');
      const isBreak = _.isEqual(taskPurpose, 'Break');
      const taskEta = _.get(task, 'routeAnalysis.eta');
      const taskEtd = _.get(task, 'routeAnalysis.etd', (taskEta + taskServiceTime));
      const relations = _.get(task, 'relations', []);
      const taskNotBefore = _.get(task, 'taskSpec.notBefore');
      const updatedAt = _.get(task, 'updatedAt');

      const taskEtaWindow = this.$filter('timeWindow')({notBefore: taskEta, notAfter: taskEtd});
      let style = isPoint ? 
        'background-color: #7E7E7E !important; color: white;' :
        'background-color: ' + routeColor + '; color: white;';

      if (isBundle) {
        style += ' box-shadow: 2px -2px 0px ' + this.commonsService.lightenDarkenColor(routeColor, -35) + ';';
      }

      return {
        ref: task,
        id: task.id,
        routeId: task.routeId,
        itemType: 'TASK',
        status: task.status,
        // id: route.rid + task.id,
        start: this.moment(taskEta),
        end: this.moment(taskEtd),
        startTime: this.moment(taskEta),
        endTime: this.moment(taskEtd),
        purpose: taskPurpose,
        taskIdList: _.get(task, 'taskIdList'), // For Bundle Only
        point: isPoint ? 'point' : 'box',
        taskType: task.taskType,
        serviceId: task.serviceId,
        serviceIds: task.bundleServiceIdList,
        // group: groupId,
        group: task.routeId,
        updatedAt: updatedAt,
        className: isPoint ? 'internal route-item' : (isBundle ? 'bundle route-item' : (isBreak ? 'task route-item break' : 'task route-item')),
        editable: {
          add: false,                             // add new items by double tapping
          updateTime: !routeRef.isBlockedByUser,  // drag items horizontally
          updateGroup: !routeRef.isBlockedByUser, // drag items from one group to another
          remove: false                           // delete an item by tapping the delete button top right
        },
        // subgroup: route.rid,
        title: this.bringozTimelineService.getRouteTaskExtendedTimelineItemTooltip(task, taskEtaWindow, undefined),
        content: isPoint ?
          this.bringozTimelineService.getRouteInternalItemContent(task, true) :
          (isBundle ?
            this.bringozTimelineService.getRouteBundleTaskTimelineItemContent(task, relations, true, index) :
            this.bringozTimelineService.getRouteTaskTimelineItemContent(task, relations, true, index)),
        style: style,
        // id: route.rid + task.id,
        bundleTasks: _.get(task, 'bundledTaskList', []), // For Bundle Only
      }
    });
  }

  // private _getItemsData(route, tasks) {
  //
  //   const isEditableRoute = this.actionsByStatusMap[route.status].editRoute;
  //   const routeColor = route.color;
  //
  //   // Guard for duplicate tasks on routes
  //   tasks = _.filter(tasks, (t) => {
  //     if (t.routeId !== route.id) {
  //       this.$log.error('Task planned on the wrong route - taskId: ' + t.id + ' task-routeId: ' + t.routeId + ' routeId: ' + route.id, t);
  //     }
  //     return t.routeId === route.id;
  //   })
  //
  //
  //   return _.map(tasks, (task, index) => {
  //
  //     if (route.analysis[task.id]) {
  //       task.analysis = route.analysis[task.id];
  //     }
  //
  //     const purpose = task.taskSpec.purpose;
  //     const isPoint = _.isEqual(task.taskType, 'Internal');
  //     const isBundle = _.isEqual(task.taskType, 'BundledStopover');
  //     const taskEta = this.leanPlanningService.getRouteTaskEta(route, task);
  //     const taskEtd = this.leanPlanningService.getRouteTaskEtd(route, task);
  //     const relations = _.get(task, 'relations', []);
  //     const taskPurpose = task.taskSpec.purpose;
  //     const itemColor = this.usePurposeColor ? this.taskPurposeToColorMap[purpose] : routeColor;
  //     const isLate = _.get(task, 'analysis.late', 0) > 0 && task.status !== 'CourierDeparted';
  //     // var taskEtd = isRelatedAgentTasks ?
  //     //     (taskEta + taskServiceTime) :
  //     //     _.get(task, 'analysis.etd', taskEta + taskServiceTime);
  //     // var taskEtd = isCompleted ? _.get(task, 'agentArrivalTime') : taskEta + taskServiceTime;
  //     const taskEtaWindow = this.$filter('timeWindow')({notBefore: taskEta, notAfter: taskEtd});
  //     const updatedAt = _.get(task, 'updatedAt');
  //
  //     return {
  //       id: task.id,
  //       // id: route.rid + task.id,
  //       start: this.moment(taskEta),
  //       end: this.moment(taskEtd),
  //       purpose: taskPurpose,
  //       status: task.status,
  //       bundleTasks: _.get(task, 'bundledTaskList', []), // For Bundle Only
  //       point: isPoint ? 'point' : 'box',
  //       serviceId: task.serviceId,
  //       group: route.rid,
  //       routeId: route.rid,
  //       taskId: task.id,
  //       className: isPoint ? 'internal' : (isBundle ? 'bundle' : 'task'),
  //       editable: {
  //         remove: false,
  //         updateGroup: isEditableRoute,
  //         updateTime: isEditableRoute
  //       },
  //       updatedAt: updatedAt,
  //       title: this.bringozTimelineService.getRouteTaskExtendedTimelineItemTooltip(task, taskEtaWindow, relations),
  //       content: isPoint ?
  //         this.bringozTimelineService.getRouteInternalItemContent(task, true) :
  //         (isBundle ?
  //           this.bringozTimelineService.getRouteBundleTaskTimelineItemContent(task, relations, true) :
  //           this.bringozTimelineService.getRouteTaskTimelineItemContent(task, relations, true, index)),
  //       // content: isBundle ?
  //       //     bringozTimelineService.getRouteBundleTaskTimelineItemContent(task, taskEtaWindow, relations, index, true) :
  //       //     (isPoint ? bringozTimelineService.getRouteInternalItemContent(purpose.charAt(0), route.color) : bringozTimelineService.getRouteTaskTimelineItemContent(task, taskEtaWindow, relations, index, true)),
  //       // style: 'background-color: ' + itemColor + '; color: white',
  //       style: 'background-color: ' + routeColor + '; color: white',
  //     }
  //   });
  // }

  private _clearTimelineData() {
    this.groupsDataSet.clear();
    this.itemsDataSet.clear();
  }

  private _onTaskClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private _getTimelineTaskById(id) {

    if (!id) {
      return undefined;
    }

    const selectedItem = this.itemsDataSet.get({
      filter: (item) => {
        return item.id === id || item.taskId === id;
      }
    });
    return this.itemsDataSet.get(selectedItem[0] ? selectedItem[0].id : undefined)
  }

  private _canItemMove(item) {

    const groupMovingTo = _.find(this.routes, (r) => {
      return r.rid === item.group
    });

    const actions = this.leanPlanningService.getRoutesActionsMap([groupMovingTo]);

    if (!actions.editRoute) {
      this.resourcesAlertsService.timelineRouteIsBlocked();
      return false;
    }

    const canMoveToGroup = this.leanPlanningService.getRoutesActionsMap([groupMovingTo]).editRoute;

    if (!canMoveToGroup) {
      return false;
    }

    const orderedItems = this.timeline.components[3].groups[item.group].orderedItems.byStart;
    const itemIndex = _.findIndex(orderedItems, (orderedItem: any) => {
      return orderedItem.data.taskId === item.taskId;
    });
    const pickupIndexes = _
      .chain(orderedItems)
      .map((orderedItem, index) => {
        return orderedItem.purpose === 'Pickup' ? index : undefined;
      })
      .filter((pickupIndexes) => {
        return !_.isUndefined(pickupIndexes);
      })
      .value();

    return _.every(pickupIndexes, (currentValue) => {
      return currentValue < itemIndex;
    });
  }

  private _getTranslatedAgentSkills(skills, isFirstLetterOnly) {
    return _.map(skills, (s) => {
      return this._getTranslatedSkill(s, isFirstLetterOnly)
    });
  }

  private _getTranslatedSkill(skill, isFirstLetterOnly) {
    const text = this.$filter('translate')('SKILLS.' + skill);
    return isFirstLetterOnly ? text.charAt(0) : text;
  }

  private _setGroupVisibilityByQueryString(queryString) {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      group.visible = !queryString ||
        _.includes(group, queryString) ||
        _.includes(_.toLower(group.agentName), _.toLower(queryString)) ||
        _.includes(_.toLower(group.resourceName), _.toLower(queryString)) ||
        _.includes(_.toLower(group.id), _.toLower(queryString))
      updatedGroups.push(group);
    });
    this.groupsDataSet.update(updatedGroups);
    this.onFit();
  }

  private _getRouteBackgroundItem(route) {
    return {
      id: route.rid,
      start: this.moment(route.notBefore),
      end: this.moment(route.notAfter),
      group: route.rid,
      type: 'background',
      style: 'background-color: ' + route.color,
      className: 'background'
    }
  }

  private _createEyeButton(id, isEnabled) {
    const eyeButton: any = this.$eyeIcon.cloneNode(true);
    eyeButton.classList.add("md-icon-button", "eye-button", "table-button", "bringoz-icon");
    eyeButton.id = id;
    eyeButton.enabled = isEnabled;
    eyeButton.style.opacity = isEnabled ? '1' : '0.5';
    if (id) {
      eyeButton.dataset.bzAction = 'toggle-route';
      eyeButton.dataset.bzId = String(id);
    }
    return eyeButton;
  }

  private _onClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  $onDestroy() {
    if (this.container) {
      this.container.removeEventListener('click', this._onContainerClick);
      this.container = null;
    }
    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('routesTimeline', {
      bindings: {
        from: '<',
        to: '<',
        routes: '<',
        tasks: '<',
        tasksListType: '<?',
        selectedItemId: '<',
        zoom: '<',
        canEdit: '<',
        queryString: '<?',
        usePurposeColor: '<?',
        hiddenRouteIds: '&',
        onTaskSelection: '&',
        onMovedItem: '&',
        onZoomChange: '&',
        onAddSuggestionsToRoute: '&',
        onRecalcRoute: '&',
        onDeleteRoute: '&',
        onToggleRoute: '&'
      },
      template: require('./routes-timeline.html').default,
      controller: RoutesTimelineComponent
    }
  );
